import { render } from "./ShapeElementOperate.vue?vue&type=template&id=08e569b7&ts=true"
import script from "./ShapeElementOperate.vue?vue&type=script&lang=ts"
export * from "./ShapeElementOperate.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__